import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=d0673b40"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports